// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@7.1.3_@rspack+core@1.7.6_webpack@5.99.9/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/check.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.handle {
  aspect-ratio: 1;
  background-color: var(--switch-handle-bg);
  border-radius: 50%;
  content: '';
  display: block;
  transition: translate var(--default-transition);
  width: calc(var(--switch-height) - (2 * var(--switch-border-width)));

  :host([aria-checked="true"]) & {
    mask:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / var(--space-3) exclude,
        linear-gradient(black 0 0, black 0 0); /* Needed for the "exclude". */

    translate: calc(var(--switch-width) - var(--switch-height)) 0;
  }
}

/* Make the click target bigger than the visible area. */

:host(::after) {
  content: '';
  display: block;
  height: var(--space-6); /* Sibling .d-form-check wrappers must not overlap. */
  position: absolute;
  top: 50%;
  translate: 0 -50%;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./packages/ui/src/switch/switch.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,cAAc;EACd,+CAA+C;EAC/C,oEAAoE;;EAEpE;IACE;;6CAEyC,EAAE,8BAA8B;;IAEzE,6DAA6D;EAC/D;AACF;;AAEA,wDAAwD;;AACxD;EACE,WAAW;EACX,cAAc;EACd,sBAAsB,EAAE,qDAAqD;EAC7E,kBAAkB;EAClB,QAAQ;EACR,iBAAiB;EACjB,WAAW;AACb","sourcesContent":[".handle {\n  aspect-ratio: 1;\n  background-color: var(--switch-handle-bg);\n  border-radius: 50%;\n  content: '';\n  display: block;\n  transition: translate var(--default-transition);\n  width: calc(var(--switch-height) - (2 * var(--switch-border-width)));\n\n  :host([aria-checked=\"true\"]) & {\n    mask:\n        url('~@disy/cadenza-icons/check.svg') no-repeat center / var(--space-3) exclude,\n        linear-gradient(black 0 0, black 0 0); /* Needed for the \"exclude\". */\n\n    translate: calc(var(--switch-width) - var(--switch-height)) 0;\n  }\n}\n\n/* Make the click target bigger than the visible area. */\n:host(::after) {\n  content: '';\n  display: block;\n  height: var(--space-6); /* Sibling .d-form-check wrappers must not overlap. */\n  position: absolute;\n  top: 50%;\n  translate: 0 -50%;\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
